// The calendar's places in the apps (PMU-265): the Calendar page in a school's console, the public
// page and its embed (no sign-in), and a card and page in the parent app.
import { navigate, type UiPart } from "@vavr/screens/shared";
import { G } from "@vavr/screens/guardian";
import { CalendarPage } from "./console.tsx";
import { PublicCalendar } from "./public.tsx";
import { ParentCalendarCard, ParentCalendarPage } from "./guardian.tsx";
import { StaffCalendarCard, StaffCalendarPage } from "./staff.tsx";

export const calendarUi: UiPart = {
  id: "calendar",
  slots: {
    "console.nav": [{ id: "calendar", label: "Calendar", icon: "calendar", path: "calendar", title: "Calendar", permission: "calendar:view", orgKind: "school", group: "Daily", render: () => <CalendarPage /> }],
    "public.page": [
      { id: "school-calendar", path: "s/:slug", title: "School calendar", render: (p) => <PublicCalendar slug={p.slug!} /> },
      { id: "school-calendar-embed", path: "embed/s/:slug", title: "School calendar", embed: true, render: (p) => <PublicCalendar slug={p.slug!} embed /> },
    ],
    // The staff app: school staff who view the calendar (not bus crews).
    "staff.page": [{ id: "calendar", path: "calendar", title: "My timetable", tab: "class", permission: "calendar:view", render: () => <StaffCalendarPage /> }],
    "staff.footer": [{ id: "calendar", tabs: ["now", "class"], permission: "calendar:view", render: () => <StaffCalendarCard /> }],
    "guardian.home": [{ id: "calendar", render: () => <ParentCalendarCard open={() => navigate(`${G}/calendar`)} /> }],
    "guardian.page": [{ id: "calendar", path: "calendar", title: "School calendar", tab: "home", render: () => <ParentCalendarPage /> }],
  },
};
